import React, {useEffect, useState} from "react"
import {PillarsService} from "../../../../services/pillars-api.service";
import PillarViewSkeleton from "../../../skeletons/home/PillarViewSkeleton";
import {useUser} from "../../../../providers/UserContext";
import PillarCard7 from "../../../../components/dashboard/cards/pillar-card/PillarCard7";
import PillarCard8 from "../../../../components/dashboard/cards/pillar-card/PillarCard8";


export default function PillarView() {
    const [send,setSend] = useState([])
    const [loader,setLoader] = useState(true)
    const [updatePillars,setUpdatePillars] = useState(true)
    const {pointUpdate , setPointUpdate} = useUser();

    async function GetPillarsData() {
        setLoader(true)
        const response = await PillarsService.getCurrentDatPillars();
        if (response?.data?.status) {
            const pillarsData = response.data?.data?.data;

            let groupedByPillarId = {};
            pillarsData.forEach(item => {
                const { _id,pillarId, pillarInfo, questionInfo, status, content } = item;
                if (!groupedByPillarId[pillarId]) {
                    groupedByPillarId[pillarId] = {
                        mainPillarId: _id,
                        pillarId: pillarId,
                        pillarName: pillarInfo.name,
                        pillarCreatedAt: pillarInfo.createdAt,
                        pillarImage: pillarInfo.imageUrl,
                        hasInputText : questionInfo.hasInputText,
                        questions: []
                    };

                }
                const obj = {
                    mainQuestionId: _id,
                    id: questionInfo._id,
                    name: item.question,
                    points: questionInfo.point,
                    status: status,
                    questions:questionInfo.multiQuestions
                }

                if(content) obj.content = content

                groupedByPillarId[pillarId].questions.push(
                    obj
                    //     {
                    //     id: questionInfo._id,
                    //     name: item.question,
                    //     points: questionInfo.point,
                    //     status: status,
                    //     questions:questionInfo.multiQuestions
                    //
                    // }
                );
            });

            const resultArray = Object.values(groupedByPillarId);

            console.log(resultArray, 'resultArray')
            setSend(resultArray);
            setLoader(false)
            setPointUpdate(!pointUpdate)
        }
    }

    useEffect(()=>{
        GetPillarsData()
    },[updatePillars])

    if (loader){
        return <PillarViewSkeleton/>
    }

    return(
        <div className={'pillars'}>
            <h3>Pillars</h3>
            {
                send?.map((item,index)=>{
                    return(
                        <div>
                            {
                                !item.hasInputText || item.questions?.multiQuestions?.length ?
                                    <PillarCard7 GetPillarsData={GetPillarsData} loader={loader} setPillarLoader={setLoader} updatePillars={updatePillars} setUpdatePillars={setUpdatePillars} key={index} heading={item.pillarName} icon={item.pillarImage} options={item.questions} hasInputText={item.hasInputText} /> :
                                    <PillarCard8 GetPillarsData={GetPillarsData} loader={loader} setPillarLoader={setLoader} updatePillars={updatePillars} setUpdatePillars={setUpdatePillars} key={index} heading={item.pillarName} icon={item.pillarImage} options={item.questions} hasInputText={item.hasInputText} />

                            }

                            {/*{*/}
                            {/*    item.hasInputText && item.questions.length > 1 ? (*/}
                            {/*        ''*/}
                            {/*    ) : item.hasInputText ? (*/}
                            {/*        <PillarCard8*/}
                            {/*            GetPillarsData={GetPillarsData}*/}
                            {/*            loader={loader}*/}
                            {/*            setPillarLoader={setLoader}*/}
                            {/*            updatePillars={updatePillars}*/}
                            {/*            setUpdatePillars={setUpdatePillars}*/}
                            {/*            key={index}*/}
                            {/*            heading={item.pillarName}*/}
                            {/*            icon={item.pillarImage}*/}
                            {/*            options={item.questions}*/}
                            {/*            hasInputText={item.hasInputText}*/}
                            {/*        />*/}
                            {/*    ) : (*/}
                            {/*        <PillarCard7*/}
                            {/*            GetPillarsData={GetPillarsData}*/}
                            {/*            loader={loader}*/}
                            {/*            setPillarLoader={setLoader}*/}
                            {/*            updatePillars={updatePillars}*/}
                            {/*            setUpdatePillars={setUpdatePillars}*/}
                            {/*            key={index}*/}
                            {/*            heading={item.pillarName}*/}
                            {/*            icon={item.pillarImage}*/}
                            {/*            options={item.questions}*/}
                            {/*            hasInputText={item.hasInputText}*/}
                            {/*        />*/}
                            {/*    )*/}
                            {/*}*/}

                        </div>
                        )
                })
            }
        </div>
    )
}